var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "overlay-wrapper" },
    [
      _c("div", { staticClass: "table-title" }, [
        _vm.mode !== "edit"
          ? _c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.add.new")))])
          : _c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.edit")))]),
        _c("br"),
      ]),
      _c("div", { staticClass: "type box post-content source-type" }, [
        _c("div", { staticClass: "display-wrapper" }, [
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: { name: "radio-sources", type: "radio", value: "rss" },
              domProps: { checked: _vm._q(_vm.form.type, "rss") },
              on: {
                click: function ($event) {
                  return _vm.changeType("rss")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "rss")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.rss-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: {
                name: "radio-sources",
                type: "radio",
                value: "google-news",
              },
              domProps: { checked: _vm._q(_vm.form.type, "google-news") },
              on: {
                click: function ($event) {
                  return _vm.changeType("google-news")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "google-news")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.google-news-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: { name: "radio-sources", type: "radio", value: "youtube" },
              domProps: { checked: _vm._q(_vm.form.type, "youtube") },
              on: {
                click: function ($event) {
                  return _vm.changeType("youtube")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "youtube")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.youtube-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: { name: "radio-sources", type: "radio", value: "vimeo" },
              domProps: { checked: _vm._q(_vm.form.type, "vimeo") },
              on: {
                click: function ($event) {
                  return _vm.changeType("vimeo")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "vimeo")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(3),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.vimeo-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: {
                name: "radio-sources",
                type: "radio",
                value: "dailymotion",
              },
              domProps: { checked: _vm._q(_vm.form.type, "dailymotion") },
              on: {
                click: function ($event) {
                  return _vm.changeType("dailymotion")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "dailymotion")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(4),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.dailymotion-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: {
                name: "radio-sources",
                type: "radio",
                value: "pinterest",
              },
              domProps: { checked: _vm._q(_vm.form.type, "pinterest") },
              on: {
                click: function ($event) {
                  return _vm.changeType("pinterest")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "pinterest")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(5),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.pinterest-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "thumbnail" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.type,
                  expression: "form.type",
                },
              ],
              attrs: {
                name: "radio-sources",
                type: "radio",
                value: "twitter",
                disabled: true,
              },
              domProps: { checked: _vm._q(_vm.form.type, "twitter") },
              on: {
                click: function ($event) {
                  return _vm.changeType("twitter")
                },
                change: function ($event) {
                  return _vm.$set(_vm.form, "type", "twitter")
                },
              },
            }),
            _c("div", { staticClass: "thumbnail-wrapper" }, [
              _c("div", { staticClass: "thumbnail-content" }, [
                _c("div", { staticClass: "vertical-align" }, [
                  _vm._m(6),
                  _c("div", { staticClass: "thumbnail-name" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.sources.twitter-source"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "form-wrapper" }, [
        _c("div", { staticClass: "form" }, [
          _c(
            "form",
            {
              attrs: { "data-vv-scope": "form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.validate("form")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "inputx",
                    class: {
                      input: true,
                      "is-danger": _vm.errors.has("form.name"),
                    },
                    attrs: {
                      "vs-label": "Name",
                      "vs-size": "large",
                      type: "text",
                      name: "name",
                      placeholder:
                        _vm.form.name && _vm.form.name != ""
                          ? ""
                          : _vm.$t("dash.sources.name_placeholder"),
                      "data-qa": "form-source-name",
                    },
                    on: {
                      keyup: function ($event) {
                        _vm.manualName = true
                      },
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form.name"),
                        expression: "errors.has('form.name')",
                      },
                    ],
                    staticClass: "fa fa-warning",
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("form.name"),
                          expression: "errors.has('form.name')",
                        },
                      ],
                      staticClass: "help is-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("form.name")))]
                  ),
                ],
                1
              ),
              !_vm.form.type || _vm.form.type == "rss"
                ? _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "inputx lower-input",
                        class: {
                          input: true,
                          "is-danger": _vm.errors.has("form.url"),
                        },
                        attrs: {
                          "vs-label": "Url flux RSS",
                          "vs-size": "large",
                          type: "text",
                          name: "url",
                          placeholder:
                            _vm.form.url && _vm.form.url != ""
                              ? ""
                              : _vm.$t("dash.sources.url_placeholder"),
                          "data-qa": "form-source-url",
                        },
                        model: {
                          value: _vm.form.url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "url", $$v)
                          },
                          expression: "form.url",
                        },
                      }),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("form.url"),
                            expression: "errors.has('form.url')",
                          },
                        ],
                        staticClass: "fa fa-warning",
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form.url"),
                              expression: "errors.has('form.url')",
                            },
                          ],
                          staticClass: "help is-danger",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("form.url")))]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _vm.form.type == "dailymotion"
                        ? _c(
                            "div",
                            {
                              staticClass: "type box post-content source-type",
                            },
                            [
                              _c("div", { staticClass: "display-wrapper" }, [
                                _c("div", { staticClass: "thumbnail" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.searchType,
                                        expression: "searchType",
                                      },
                                    ],
                                    attrs: {
                                      name: "radio-sources",
                                      type: "radio",
                                      value: "search",
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.searchType, "search"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.searchType = "search"
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "thumbnail-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "thumbnail-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "vertical-align" },
                                            [
                                              _vm._m(7),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "thumbnail-name",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.sources.search"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "thumbnail" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.searchType,
                                        expression: "searchType",
                                      },
                                    ],
                                    attrs: {
                                      name: "radio-sources",
                                      type: "radio",
                                      value: "tag",
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.searchType, "tag"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.searchType = "tag"
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "thumbnail-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "thumbnail-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "vertical-align" },
                                            [
                                              _vm._m(8),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "thumbnail-name",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.sources.tag"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "thumbnail" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.searchType,
                                        expression: "searchType",
                                      },
                                    ],
                                    attrs: {
                                      name: "radio-sources",
                                      type: "radio",
                                      value: "user",
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.searchType, "user"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.searchType = "user"
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "thumbnail-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "thumbnail-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "vertical-align" },
                                            [
                                              _vm._m(9),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "thumbnail-name",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.sources.user"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.form.type == "google-news"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.language,
                                  expression: "form.language",
                                },
                              ],
                              staticClass: "lang",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.form,
                                    "language",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.languages, function (lang, key) {
                              return _c(
                                "option",
                                { key: key, domProps: { value: lang } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(`dash.languages.${lang.name}`)
                                    )
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "inputx lower-input",
                        class: {
                          input: true,
                          "is-danger": _vm.errors.has("form.custom_field"),
                        },
                        attrs: {
                          "vs-label": "Url flux RSS",
                          "vs-size": "large",
                          type: "text",
                          name: "custom_field",
                          placeholder:
                            _vm.form.custom_field && _vm.form.custom_field != ""
                              ? ""
                              : _vm.$t(
                                  `dash.sources.custom_field_placeholder-${_vm.form.type}`
                                ),
                          "data-qa": "form-source-custom_field",
                        },
                        model: {
                          value: _vm.form.custom_field,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "custom_field", $$v)
                          },
                          expression: "form.custom_field",
                        },
                      }),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("form.custom_field"),
                            expression: "errors.has('form.custom_field')",
                          },
                        ],
                        staticClass: "fa fa-warning",
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form.custom_field"),
                              expression: "errors.has('form.custom_field')",
                            },
                          ],
                          staticClass: "help is-danger",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("form.custom_field")))]
                      ),
                    ],
                    1
                  ),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c(
                    "vs-checkbox",
                    {
                      model: {
                        value: _vm.form.evergreen,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "evergreen", $$v)
                        },
                        expression: "form.evergreen",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("dash.sources.evergreen_placeholder"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm.mode !== "edit"
        ? _c(
            "vs-button",
            {
              staticClass: "btn-img sources-btn",
              attrs: {
                color: "#2F1937",
                size: "large",
                "vs-type": "filled",
                "data-qa": "form-source-submit",
              },
              on: { click: _vm.submit },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.submit")))]),
              _c("img", {
                staticClass: "icon-white",
                attrs: {
                  src: require("../../../assets/img/icon_launch.svg"),
                  alt: "posted",
                },
              }),
            ]
          )
        : _c(
            "vs-button",
            {
              staticClass: "btn-img sources-btn",
              attrs: {
                color: "#2F1937",
                size: "large",
                "vs-type": "filled",
                "data-qa": "form-source-submit",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.update.apply(null, arguments)
                },
              },
            },
            [_c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.save")))])]
          ),
      _c("div", { staticClass: "close-btn", on: { click: _vm.cancel } }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/rss-source.svg"),
          alt: "rss",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/google-news-source.svg"),
          alt: "google-news",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/logo-youtube.svg"),
          alt: "youtube-source",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/vimeo-source.svg"),
          alt: "vimeo-source",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/dailymotion-source.svg"),
          alt: "dailymotion-source",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/pinterest-source.svg"),
          alt: "pinterest-source",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/twitter-source.svg"),
          alt: "twitter-source",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/source-search_type-search.svg"),
          alt: "search",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/source-search_type-tag.svg"),
          alt: "tag",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumbnail-img-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/source-search_type-user.svg"),
          alt: "user",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }